import axios from 'axios';
import { handleRequest, handleResponseException } from "./main.js";
import { hideLoading } from "./loading.js";
import { handleError } from "./error.js"

// 创建一个AXIOS实例
const service = axios.create(
  {
    baseURL:'https://mgt.dinghanwang.com/prod-api',
    timeout: 180000,  // 请求超时（单位：毫秒）
    withCredentials: true
  });

// Request Interceptor
service.interceptors.request.use(
  config =>
  {
    handleRequest(config.headers);
    return config;
  },
  error =>
  {
    return Promise.reject(error);
  }
)

// Response Interceptor
service.interceptors.response.use(
  response =>
  {
    hideLoading()
    // 文件流响应直接返回，不做code校验
    if (response.config.responseType === 'blob') {
      return response;
    }
    const res = response.data;
    if (res.code !== 200) {
      handleError(response, response.config.headers);
      return Promise.reject(new Error(res.msg || '请求失败'));
    }
    return res;
  },
  error =>
  {
    hideLoading()
    if (error.response) {
      handleResponseException(error.response.config.headers, error.response);
    } else {
      let response =
      {
        status: "响应超时",
        statusText: "请求已经发送，但接收应答响应超时",
      }
      handleResponseException(error.config.headers, response);
    }
    return Promise.reject(error)
  }
)

export default service
